"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  z50: "#FCF8F9",
  z100: "#F9E1EB",
  z200: "#F8A3C7",
  z300: "#FB77AE",
  z400: "#F74E95",
  z500: "#E8307D",
  z600: "#D61B69",
  z700: "#BD0F58",
  z800: "#81073A",
  z900: "#66002B"
};
exports["default"] = _default;